import type { ICellRendererParams } from "ag-grid-community";
import { useMemo } from "react";

import { GroupMappingTableRow } from "./types";

import { Badge, BadgeVariant } from "@/components/ui/Badge";
import { OverflowDisplayTooltip } from "@/components/ui/Tooltip/OverflowDisplayTooltip";
import { TableColumn } from "@/components/ui/TableV2";
import { capitalize } from "@/utils/strings";

export const useGroupMappingsColumns = () => {
  const columns = useMemo<TableColumn<GroupMappingTableRow>[]>(
    () => [
      {
        id: 1,
        name: "idp_group",
        field: "idp_group_name",
        header: "IdP group",
        sortable: false,
        minWidth: 180,
        flex: 1,
        cellClass: "justify-start text-left",
        headerClass: "!justify-start !text-left",
        cellRenderer: (params: ICellRendererParams<GroupMappingTableRow>) => (
          <div className="flex h-full w-full items-center justify-start px-3 text-left">
            <OverflowDisplayTooltip content={params.data?.idp_group_name ?? ""}>
              <span className="truncate text-sm font-medium text-gray-900">
                {params.data?.idp_group_name}
              </span>
            </OverflowDisplayTooltip>
          </div>
        ),
      },
      {
        id: 2,
        name: "workspace",
        field: "workspace_name",
        header: "Workspace",
        sortable: false,
        minWidth: 160,
        flex: 1,
        cellClass: "justify-start text-left",
        headerClass: "!justify-start !text-left",
        cellRenderer: (params: ICellRendererParams<GroupMappingTableRow>) => (
          <div className="flex h-full w-full items-center justify-start px-3 text-left">
            <OverflowDisplayTooltip content={params.data?.workspace_name ?? ""}>
              <span className="truncate text-sm text-gray-700">{params.data?.workspace_name}</span>
            </OverflowDisplayTooltip>
          </div>
        ),
      },
      {
        id: 3,
        name: "role",
        field: "assigned_role",
        header: "Role",
        sortable: false,
        minWidth: 120,
        maxWidth: 160,
        cellClass: "justify-start text-left",
        headerClass: "!justify-start !text-left",
        cellRenderer: (params: ICellRendererParams<GroupMappingTableRow>) => (
          <div className="flex h-full w-full items-center justify-start px-3 text-left">
            <Badge variant={BadgeVariant.BLUE} className="capitalize">
              {capitalize(params.data?.assigned_role ?? "")}
            </Badge>
          </div>
        ),
      },
    ],
    [],
  );

  return { columns };
};
